import React from 'react'
import Heroabout from '../components/Heroabout';
import Mission from '../components/Mission';
import Footer from '../components/Footer';
import { Reveal } from '../components/reveal';
import { img2 } from '../assets';

const About = () => {
  return (
    <div className='w-full bg-primary items-center flex flex-col'>
      <div 
        style={{ 
          backgroundImage: `url(${img2})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }}
        className={`w-full relative overflow-hidden`}
      > 
        <Heroabout />
        <div className="w-full gradient-04 z-0" />
        <div className='w-full items-center justify-center flex flex-col gap-6 pb-20 px-10'>
          <Reveal>
            <h1 className="kerning-normal pt-20 xs:pt-20 px-4 text-center text-white font-semibold text-md leading-[40px] xs:leading-[50px] xs:max-w-[840px] max-w-[400px]">
              Patient capital + hands-on scaling. Backing businesses that unlock new markets.
            </h1>
          </Reveal>
        </div>
        <Mission />
      </div>
      <Footer />
    </div>
  )
}
export default About;